export default __webpack_public_path__ + "static/media/hostfully_step11.b8145551.png";